import { map } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { TenantService } from "./tenant.service";

@Injectable({ providedIn: 'root' })
export class LabelService {

    constructor(private tenantService: TenantService) {}

    labelFor(labelKey, defaultLabel) {
        return this.tenantService.getUnauthTenantInfo()
        .pipe(
            map(tenant => {
                let labels = typeof tenant.settings.labels === 'string' ? JSON.parse(tenant.settings.labels) : tenant.settings.labels;
                return labels && labels[labelKey] ? labels[labelKey] : defaultLabel;  
            })
        );
    }

};
